import { createMutableAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';

const mobileInitializerAction = () => createMutableAction(ActionTypes.MOBILE_INITIALIZER, null);

export default mobileInitializerAction;
